import React from 'react';
import RateCard from '../../cards/rateCard/rateCard';
import RateGroupCard from '../../cards/rateGroupCard/rateGroupCard';
import Total from '../../misc/total/total';
import Button from '../../ui/button/button';
import Message from '../../misc/message/message';
import { useTranslation } from 'react-i18next';
import { UUID } from '../../../../utils/utils';
import './ticketMarket.css';


export default function TicketMarket({onSubmit = () => {}, config, isSubmitting = false, isGoingBack = false}) {
    const { t } = useTranslation();
    const max_ticket = config.ticket_market.max_ticket_per_order;
    const title = config.ticket_market.header.title;
    const subtitle = config.ticket_market.header.subtitle;
    const informationTitle = config.ticket_market.message?.title;
    const informationDescription = config.ticket_market.message?.description;
    const { expand_rate_groups, display_rate_description } = config.ticket_market.settings;
    const totalData = config.ticket_market.total;
    const rates_with_group = config.ticket_market.rates_with_group;
    const rates_without_group = config.ticket_market.rates;
    const [selectedRates, setSelectedRates] = React.useState({});

    const sortWithDisplayOrder = (a, b) => Object.keys(a).includes('display_order') &&
        Object.keys(b).includes('display_order') ? a['display_order'] - b['display_order'] :
        Object.keys(b).includes('display_order') ? -1 : 1;

    const ratesWithGroup = React.useMemo(() => rates_with_group.sort(sortWithDisplayOrder), [rates_with_group]);
    const ratesWithoutGroup = React.useMemo(() => rates_without_group.sort(sortWithDisplayOrder), [rates_without_group]);

    const total = React.useMemo(() => {
        let quantity = 0;
        let price = 0;
        for (const rate in selectedRates) {
            quantity += selectedRates[rate]['quantity'];
            price += selectedRates[rate]['price'];
        }
        return { "quantity": quantity, "price": price };
    }, [selectedRates]);

    const isDisabledSubmit = React.useMemo(() => {
        return total.quantity === 0 || total.quantity > max_ticket || isGoingBack;
    }, [total, max_ticket, isGoingBack]);

    const _onSubmit = React.useCallback(() => {
        if (isDisabledSubmit) {
            return;
        }
        let selected_rates = [];
        for (const [key, value] of Object.entries(selectedRates)) {
            for (let i = 0; i < value.quantity; i++) {
                selected_rates.push({
                    "auto_generated_ticket_id": UUID(key),
                    "rate": Number(key),
                    "booking":{
                        "booking_uuid": null,
                    },
                });
            }
        }       
        onSubmit({
            data: {
                cart: {'attendees': selected_rates, 'buyer': {}}
            }
        });
    },[selectedRates, onSubmit, isDisabledSubmit]);

    return (
        <div className='neo-rate-step'>
            {informationTitle && informationDescription && <Message type='info' title={informationTitle} description={informationDescription} />}
            <h1 className='neo-rate-step-rates-title'>{title}</h1>
            <h2 className='neo-rate-step-rates-subtitle'>{subtitle}</h2>
            <div>
                {ratesWithoutGroup?.map((rate, i) => {
                    return <RateCard key={i} rate={rate} selectedRates={selectedRates} setSelectedRates={setSelectedRates} disable_plus={isSubmitting} disable_minus={isSubmitting} max_ticket={max_ticket} display_rate_description={display_rate_description} currency={totalData.currency}/>
                })}
                {ratesWithGroup?.map((group, i) => {
                    return <RateGroupCard key={i} className='neo-parent-group' group={group} selectedRates={selectedRates} setSelectedRates={setSelectedRates} disable_plus={isSubmitting} disable_minus={isSubmitting} max_ticket={max_ticket} expand_rate_groups={expand_rate_groups} currency={totalData.currency}/>
                })}
                <Total totalData={totalData} quantity={total.quantity} total={total.price}/>
            </div>
            <div className='neo-cta-container'>
                <Button type='primary' isLoading={isSubmitting} className='neo-cta-next' onClick={_onSubmit} label={t('widget.resale.tickets.cta-next')} disabled={isDisabledSubmit}/>
            </div>
        </div>
    )
}
